import { Component, Input } from '@angular/core';
import { Card } from 'primeng/card';


@Component({
  selector: 'app-page-layout',
  standalone: true,
  imports: [Card],
  templateUrl: './page-layout.html'
})
export class PageLayoutComponent {

  @Input('pageTitle') title!: string;
  @Input() subtitle?: string;

}
